import axios from 'axios';
import apiConfig from '../api.config';

export default function getPaymentMethodsRequest(userId) {
  const {
    host,
    URIs: { getPaymentMethods },
  } = apiConfig;

  const uri = `${host}${getPaymentMethods}`.replace(':userId', userId);

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
